import { format } from 'date-fns'

export const eventStartDTO = {
    name: '',
    isActive: true,
    isVisible: true,
    isControlCompany: false,
    typeForm: 'company',
    isInstallments: false,
    isCourse: false,
    start_subscription: format(new Date(), 'yyyy-MM-dd'),
    end_subscription: format(new Date(), 'yyyy-MM-dd'),
    max_subscribers: null,
    plans: [],
    hostings: [],
    position: null,
    collectors: [],
    certificate: '',
    speakerCertificate: null,
    city: '',
    uf: '',
    due_date: 15,
    payment_options: {"Pix": false,"Boleto": true, "Transação ou Depósito Bancário": false,"Nota de empenho/depósito bancário": false},
    date_initial: null,
    date_finish: null,
    thumbnail: '',
    apresentation:'',
    terms:'',
    location:'',
    location_address:'',
    scheduling:'',
    information_accommodation: '',
    counter_hostings: {},
}
